export default {"src":"/_next/static/media/about6.b83ff111.svg","height":431,"width":634};